import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, message, Button, Dropdown, Menu } from "antd";
import TableComponent from "../../components/TableComponent";
import { API_ENDPOINTS } from "../../utils/constants";
import { axiosInstance } from "../../utils/axiosInstance";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate } from "react-router-dom";
import { tableDateFormatter } from "../../utils/formatDate";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonComponent,
	StatusCell
} from "./styles";
import { AxiosResponse } from "axios";
import { useCDNFileContext } from "../../context/CDNFileContext/CDNFileContext";

interface CDNFiles {
	cdnFileId: string;
	title: string;
	releaseDate: string;
	displayOrder: number;
	isVisible: boolean;
	isDeleted: boolean;
}
interface CDNFileListApiResponse {
	result: {
		items: CDNFiles[];
	};
	error: string | null;
	isSuccessful: boolean;
}

const CDNFileList = () => {
	const [tableData, setTableData] = useState<any[]>([]);
	const [pageLoading, setPageLoading] = useState(true);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { clearCDNFileData } = useCDNFileContext();


	const navigate = useNavigate();

	const getCDNFileList = async () => {
		setPageLoading(true);
		try {
			const response: AxiosResponse<CDNFileListApiResponse> = await axiosInstance.get(
				API_ENDPOINTS.GET_CDN_FILE_LIST
			);

			setTableData(response?.data?.result?.items);
		} catch (error) {
			return [[], false];
		} finally {
			setPageLoading(false);
		}
	};

	const handleDelete = async (cdnFileId: string) => {
		try {
			console.log(cdnFileId);
			await axiosInstance.post(API_ENDPOINTS.REMOVE_CDN_FILE, { cdnFileId });
			message.success("CDN Dosyası başarıyla silindi.");
			getCDNFileList();
		} catch (error) {
			message.error("CDN Dosyası silinirken bir hata oluştu.");
		} finally {
			setIsModalVisible(false);
		}
	};

	useEffect(() => {
		getCDNFileList();
		clearCDNFileData();
	}, []);


	const columns = useMemo(() => [
		createColumn({
			title: "Sıra",
			dataIndex: "displayOrder",
			width: 30,
			sorterType: "numeric",
		}),
		createColumn({
			title: "Başlık",
			dataIndex: "title",
			width: 50,
			sorterType: "string",
		}),
		createColumn({
			title: "Url",
			dataIndex: "imageUrl",
			width: 250,
			sorterType: "string",
			render: (url) => (
				<a href={url} target="_blank" rel="noopener noreferrer">
					{url}
				</a>
			),
		}),
		createColumn({
			title: "Tarih",
			dataIndex: "releaseDate",
			width: 50,
			sorterType: "string",
			render: (text) => tableDateFormatter(text, "DD.MM.YYYY"),
		}),
		createColumn({
			title: "Durum",
			dataIndex: "isVisible",
			width: 50,
			sorterType: "boolean",
			render: (text, record) => (
				<StatusCell $isVisible={!record.isVisible}>{!record.isVisible ? "Pasif" : "Aktif"}</StatusCell>
			),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record: any) => {
				const menu = (
					<Menu>
						<Menu.Item key="edit" onClick={() => navigate(`/edit-cdn-file/${record.cdnFileId}`)}>
							Güncelle
						</Menu.Item>
						<Menu.Item key="delete" onClick={() => {
							setCurrentItem(record);
							setIsModalVisible(true);
						}}>
							Sil
						</Menu.Item>
					</Menu>
				);

				return (
					<Dropdown overlay={menu} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			},
		}),
	], [tableData]);


	return (
		<div>
			<HeaderComponent>CDN Dosyaları</HeaderComponent>
			<Container>
				<Spin spinning={pageLoading}>
					<ContainerHeader>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate("/add-cdn-file")}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonComponent>
					</ContainerHeader>
				</Spin>
				{!pageLoading && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>

			<Modal
				title="CDN Dosyasını Sil"
				visible={isModalVisible}
				onOk={() => handleDelete(currentItem?.cdnFileId)}
				onCancel={() => setIsModalVisible(false)}
				okText="Evet"
				cancelText="Hayır"
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						key="submit"
						type="primary"
						danger
						onClick={() => handleDelete(currentItem?.cdnFileId)}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.title}"`}</strong> dosyasını silmek istediğinizden emin misiniz?</p>
			</Modal>
		</div>
	);
};

export default CDNFileList;
